import type { OnboardStep } from "@/components/voice-onboarding/WelcomeFrame";

/** The 7 onboarding wizard steps (shared by every step page for the pips). */
export const VOICE_ONBOARD_STEPS: OnboardStep[] = [
  { id: "welcome", label: "Welcome" },
  { id: "pick", label: "Pick a genie" },
  { id: "business", label: "Your business" },
  { id: "building", label: "Build the brain" },
  { id: "meet", label: "Make it yours" },
  { id: "test", label: "Test it" },
  { id: "launch", label: "Launch" },
];

/** Route order for Back/Continue wiring. */
export const ONBOARD_ROUTES = [
  "/welcome",
  "/welcome/pick",
  "/welcome/business",
  "/welcome/building",
  "/welcome/meet",
  "/welcome/test",
  "/welcome/launch",
] as const;
